"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Module = void 0;
var typeorm_1 = require("typeorm");
var Tag_1 = require("./Tag");
var Video_1 = require("./Video");
var CodingQuestion_1 = require("./CodingQuestion");
var GithubAssignmentQuestion_1 = require("./GithubAssignmentQuestion");
var ConceptualQuestion_1 = require("./ConceptualQuestion");
var ModuleType;
(function (ModuleType) {
  ModuleType["PRECOURSE"] = "PRECOURSE";
  ModuleType["ASSIGNMENT"] = "ASSIGNMENT";
  ModuleType["WEB_ASSIGNMENT"] = "WEB_ASSIGNMENT";
  ModuleType["CONCEPTUAL_QUESTIONS"] = "CONCEPTUAL_QUESTIONS";
  ModuleType["VIDEOCLASS"] = "VIDEOCLASS";
  ModuleType["OTHER"] = "OTHER";
  ModuleType["ASSIGNMENT_TEMPLATE"] = "ASSIGNMENT_TEMPLATE";
})(ModuleType || (ModuleType = {}));
var Module = /** @class */function () {
  function Module() {}
  __decorate([(0, typeorm_1.PrimaryGeneratedColumn)("uuid"), __metadata("design:type", String)], Module.prototype, "id", void 0);
  __decorate([(0, typeorm_1.Column)({
    nullable: false
  }), __metadata("design:type", String)], Module.prototype, "name", void 0);
  __decorate([(0, typeorm_1.Column)({
    nullable: false
  }), __metadata("design:type", String)], Module.prototype, "description", void 0);
  __decorate([(0, typeorm_1.Column)({
    nullable: true
  }), __metadata("design:type", String)], Module.prototype, "imageUrl", void 0);
  __decorate([(0, typeorm_1.ManyToMany)(function () {
    return Tag_1.Tag;
  }), (0, typeorm_1.JoinTable)({
    name: "module_tag_m2m"
  }), __metadata("design:type", Array)], Module.prototype, "tags", void 0);
  __decorate([(0, typeorm_1.ManyToMany)(function () {
    return Video_1.Video;
  }), (0, typeorm_1.JoinTable)({
    name: "module_video_m2m"
  }), __metadata("design:type", Array)], Module.prototype, "videos", void 0);
  __decorate([(0, typeorm_1.ManyToMany)(function () {
    return CodingQuestion_1.CodingQuestion;
  }), (0, typeorm_1.JoinTable)({
    name: "module_coding_question_m2m"
  }), __metadata("design:type", Array)], Module.prototype, "codingQuestions", void 0);
  __decorate([(0, typeorm_1.ManyToMany)(function () {
    return GithubAssignmentQuestion_1.GithubAssignmentQuestion;
  }), (0, typeorm_1.JoinTable)({
    name: "module_github_question_m2m"
  }), __metadata("design:type", Array)], Module.prototype, "githubQuestions", void 0);
  __decorate([(0, typeorm_1.ManyToMany)(function () {
    return ConceptualQuestion_1.ConceptualQuestion;
  }), (0, typeorm_1.JoinTable)({
    name: "module_conceptual_question_m2m"
  }), __metadata("design:type", Array)], Module.prototype, "conceptualQuestions", void 0);
  __decorate([(0, typeorm_1.Column)({
    default: ModuleType.PRECOURSE,
    type: "enum",
    enum: ModuleType
  }), __metadata("design:type", String)], Module.prototype, "type", void 0);
  __decorate([(0, typeorm_1.CreateDateColumn)({
    default: "2022-06-01 01:00:00.000"
  }), __metadata("design:type", Date)], Module.prototype, "live_at", void 0);
  __decorate([(0, typeorm_1.CreateDateColumn)(), __metadata("design:type", Date)], Module.prototype, "created_at", void 0);
  __decorate([(0, typeorm_1.UpdateDateColumn)(), __metadata("design:type", Date)], Module.prototype, "updated_at", void 0);
  Module = __decorate([(0, typeorm_1.Entity)()], Module);
  return Module;
}();
exports.Module = Module;